export const stopwords = [
  'aderton',
  'adertonde',
  'adjö',
  'aldrig',
  'all',
  'alla',
  'allas',
  'allt',
  'alltid',
  'alltså',
  'andra',
  'andras',
  'annan',
  'annat',
  'artonde',
  'artonn',
  'att',
  'av',
  'bakom',
  'bara',
  'behöva',
  'behövas',
  'behövde',
  'behövt',
  'beslut',
  'beslutat',
  'beslutit',
  'bland',
  'blev',
  'bli',
  'blir',
  'blivit',
  'borde',
  'bort',
  'borta',
  'bra',
  'bäst',
  'bättre',
  'båda',
  'bådas',
  'både',
  'dag',
  'dagar',
  'dagarna',
  'dagen',
  'de',
  'del',
  'delen',
  'dem',
  'den',
  'denna',
  'deras',
  'dess',
  'dessa',
  'det',
  'detta',
  'dig',
  'din',
  'dina',
  'dit',
  'ditt',
  'dock',
  'dom',
  'du',
  'där',
  'därför',
  'då',
  'efter',
  'eftersom',
  'elfte',
  'eller',
  'elva',
  'en',
  'enkel',
  'enkelt',
  'enkla',
  'enligt',
  'er',
  'era',
  'ert',
  'ett',
  'ettusen',
  'fall',
  'fanns',
  'fast',
  'fem',
  'femte',
  'femtio',
  'femtionde',
  'femton',
  'femtonde',
  'fick',
  'fin',
  'finnas',
  'finns',
  'fjorton',
  'fjortonde',
  'fjärde',
  'fler',
  'flera',
  'flesta',
  'fram',
  'framför',
  'från',
  'fyra',
  'fyrtio',
  'fyrtionde',
  'få',
  'får',
  'fått',
  'följande',
  'för',
  'före',
  'förlåt',
  'förra',
  'första',
  'ge',
  'genast',
  'genom',
  'ger',
  'gick',
  'gjorde',
  'gjort',
  'god',
  'goda',
  'godare',
  'godast',
  'gott',
  'gälla',
  'gäller',
  'gällt',
  'gärna',
  'gå',
  'gång',
  'går',
  'gått',
  'gör',
  'göra',
  'ha',
  'hade',
  'haft',
  'han',
  'hans',
  'har',
  'hela',
  'heller',
  'hellre',
  'helst',
  'helt',
  'henne',
  'hennes',
  'heter',
  'hit',
  'hjälp',
  'hon',
  'honom',
  'hundra',
  'hundraen',
  'hundraett',
  'hur',
  'här',
  'hög',
  'höger',
  'högre',
  'högst',
  'i',
  'ibland',
  'idag',
  'igen',
  'igår',
  'imorgon',
  'in',
  'inför',
  'inga',
  'ingen',
  'ingenting',
  'inget',
  'innan',
  'inne',
  'inom',
  'inte',
  'inuti',
  'ja',
  'jag',
  'jämfört',
  'kan',
  'kanske',
  'knappast',
  'kolla',
  'kom',
  'komma',
  'kommer',
  'kommit',
  'kr',
  'kunde',
  'kunna',
  'kunnat',
  'kvar',
  'kör',
  'legat',
  'ligga',
  'ligger',
  'lika',
  'likställd',
  'likställda',
  'lilla',
  'lite',
  'liten',
  'litet',
  'lägga',
  'länge',
  'längre',
  'längst',
  'lätt',
  'lättare',
  'lättast',
  'långsam',
  'långsammare',
  'långsammast',
  'långsamt',
  'långt',
  'man',
  'med',
  'mellan',
  'men',
  'menar',
  'mer',
  'mera',
  'mest',
  'mig',
  'min',
  'mina',
  'mindre',
  'minst',
  'mitt',
  'mittemot',
  'mot',
  'mycket',
  'många',
  'måste',
  'möjlig',
  'möjligen',
  'möjligt',
  'möjligtvis',
  'ned',
  'nederst',
  'nedersta',
  'nedre',
  'nej',
  'ner',
  'ni',
  'nio',
  'nionde',
  'nittio',
  'nittionde',
  'nitton',
  'nittonde',
  'nog',
  'noll',
  'nr',
  'nu',
  'nummer',
  'när',
  'nästa',
  'någon',
  'någonting',
  'något',
  'några',
  'nån',
  'nåt',
  'nödvändig',
  'nödvändiga',
  'nödvändigt',
  'nödvändigtvis',
  'och',
  'också',
  'ofta',
  'oftast',
  'olika',
  'olikt',
  'om',
  'oss',
  'på',
  'rakt',
  'redan',
  'rätt',
  'sade',
  'sagt',
  'samma',
  'samt',
  'sedan',
  'sen',
  'senare',
  'senast',
  'sent',
  'sex',
  'sextio',
  'sextionde',
  'sexton',
  'sextonde',
  'sig',
  'sin',
  'sina',
  'sist',
  'sista',
  'siste',
  'sitt',
  'sju',
  'sjunde',
  'sjuttio',
  'sjuttionde',
  'sjutton',
  'sjuttonde',
  'själv',
  'sjätte',
  'ska',
  'skall',
  'skulle',
  'slutligen',
  'små',
  'smått',
  'snart',
  'som',
  'stor',
  'stora',
  'stort',
  'står',
  'större',
  'störst',
  'säga',
  'säger',
  'sämre',
  'sämst',
  'sätt',
  'så',
  'ta',
  'tack',
  'tar',
  'tidig',
  'tidigare',
  'tidigast',
  'tidigt',
  'till',
  'tills',
  'tillsammans',
  'tio',
  'tionde',
  'tjugo',
  'tjugoen',
  'tjugoett',
  'tjugonde',
  'tjugotre',
  'tjugotvå',
  'tjungo',
  'tolfte',
  'tolv',
  'tre',
  'tredje',
  'trettio',
  'trettionde',
  'tretton',
  'trettonde',
  'tro',
  'tror',
  'två',
  'tvåhundra',
  'under',
  'upp',
  'ur',
  'ursäkt',
  'ut',
  'utan',
  'utanför',
  'ute',
  'vad',
  'var',
  'vara',
  'varför',
  'varifrån',
  'varit',
  'varje',
  'varken',
  'varsågod',
  'vart',
  'vem',
  'vems',
  'verkligen',
  'vet',
  'vi',
  'vid',
  'vidare',
  'viktig',
  'viktigare',
  'viktigast',
  'viktigt',
  'vilka',
  'vilken',
  'vilket',
  'vill',
  'visst',
  'väl',
  'vänster',
  'vänstra',
  'värre',
  'vår',
  'våra',
  'vårt',
  'än',
  'ändå',
  'ännu',
  'är',
  'även',
  'åtminstone',
  'åtta',
  'åttio',
  'åttionde',
  'åttonde',
  'över',
  'övermorgon',
  'överst',
  'övre',
  'nya',
  'ny',
  'procent',
  'ser',
  'skriver',
  'tog',
  'året',
]
